export default __webpack_public_path__ + "static/plant-c12e202c4fe08584f845502745af997f.png";